// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.c-thread-card[data-v-e7e20144] {\n  background-color: transparent;\n}\n.c-outer-thread[data-v-e7e20144] {\n}\n.c-inner-thread[data-v-e7e20144] {\n  border-left: solid 1px grey;\n  padding-left: 16px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
